module.exports = __webpack_public_path__ + "img/list.077e5adc.svg";